<template>
    <div
        :class="`bg-${color}-lighter border-${color}`"
        class="flex w-full p-3 mb-6 border rounded shadow"
    >
        <base-svg
            name="icon-important-circle-large"
            :class="[
                `fill-primary-${color}-dark`,
                `fill-secondary-${color}-light`,
            ]"
            class="flex-none w-6 h-6 mr-3"
        />
        <div class="flex-grow">
            <h6
                :class="`text-${color}-darker`"
                class="text-base"
            >
                <slot name="heading" />
            </h6>

            <div
                :class="`text-${color}-darker`"
                class="text-sm"
            >
                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            level: {
                type: String,
                required: true,
                validator (value) {
                    return ['info', 'warning', 'danger'].includes(value)
                }
            }
        },
        computed: {
            color () {
                switch (this.level) {
                    case 'danger':
                        return 'red'
                    case 'info':
                        return 'blue'
                    default:
                        return 'yellow'
                }
            }
        }
    }
</script>
